 
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const CreateCharts = /* GraphQL */ `mutation CreateCharts($input: SaveChartInput!) {
  CreateCharts(input: $input) {
    athenaExecutionId
    chartId
    chartImageUrl
    chartType
    config
    createdAt
    createdBy
    dashboardIds
    description
    executionId
    lastModifiedAt
    lastModifiedBy
    name
    orgId
    queryId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateChartsMutationVariables,
  APITypes.CreateChartsMutation
>;
export const CreateDashboard = /* GraphQL */ `mutation CreateDashboard($input: SaveDashboardInput!) {
  CreateDashboard(input: $input) {
    chartIds
    createdAt
    createdBy
    dashboardId
    dashboardImageUrl
    description
    lastModifiedAt
    lastModifiedBy
    name
    orgId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateDashboardMutationVariables,
  APITypes.CreateDashboardMutation
>;
export const CreateNotification = /* GraphQL */ `mutation CreateNotification($input: CreateNotificationInput!) {
  CreateNotification(input: $input) {
    createdAt
    createdBy
    isRead
    notificationId
    orgId
    payload
    readAt
    readBy
    username
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateNotificationMutationVariables,
  APITypes.CreateNotificationMutation
>;
export const CreateQueryTemplate = /* GraphQL */ `mutation CreateQueryTemplate($input: CreateQueryTemplateInput!) {
  CreateQueryTemplate(input: $input) {
    created {
      orgId
      templateId
      __typename
    }
    error
    failed {
      orgId
      reason
      __typename
    }
    message
    templateKey
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateQueryTemplateMutationVariables,
  APITypes.CreateQueryTemplateMutation
>;
export const CreateUser = /* GraphQL */ `mutation CreateUser($userRequest: CreateUserInput!) {
  CreateUser(userRequest: $userRequest) {
    message
    success
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateUserMutationVariables,
  APITypes.CreateUserMutation
>;
export const DeleteChartOrDashboard = /* GraphQL */ `mutation DeleteChartOrDashboard($input: DeleteChartOrDashboardInput!) {
  DeleteChartOrDashboard(input: $input) {
    message
    statusCode
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteChartOrDashboardMutationVariables,
  APITypes.DeleteChartOrDashboardMutation
>;
export const DeleteHistory = /* GraphQL */ `mutation DeleteHistory($input: DeleteHistoryInput!) {
  DeleteHistory(input: $input) {
    message
    statusCode
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteHistoryMutationVariables,
  APITypes.DeleteHistoryMutation
>;
export const DeleteNotification = /* GraphQL */ `mutation DeleteNotification($input: DeleteNotificationInput!) {
  DeleteNotification(input: $input) {
    message
    statusCode
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteNotificationMutationVariables,
  APITypes.DeleteNotificationMutation
>;
export const DeleteSchedule = /* GraphQL */ `mutation DeleteSchedule($input: DeleteScheduleInput!) {
  DeleteSchedule(input: $input) {
    message
    schedulerId
    success
    successCode
    __typename
  }
}
` as GeneratedMutation<
  APITypes.DeleteScheduleMutationVariables,
  APITypes.DeleteScheduleMutation
>;
export const EditDashboard = /* GraphQL */ `mutation EditDashboard($input: SaveDashboardInput!) {
  EditDashboard(input: $input) {
    chartIds
    createdAt
    createdBy
    dashboardId
    dashboardImageUrl
    description
    lastModifiedAt
    lastModifiedBy
    name
    orgId
    __typename
  }
}
` as GeneratedMutation<
  APITypes.EditDashboardMutationVariables,
  APITypes.EditDashboardMutation
>;
export const NotifyQueryValidation = /* GraphQL */ `mutation NotifyQueryValidation($input: QueryValidationNotifyInput!) {
  NotifyQueryValidation(input: $input) {
    athenaExecutionId
    createdAt
    createdBy
    executionDuration
    executionId
    executionSource
    executionStatus
    lastModifiedAt
    lastModifiedBy
    orgId
    query
    queryDescription
    queryId
    queryName
    segmentedFanCount
    status
    validationLogs
    validationStatus
    __typename
  }
}
` as GeneratedMutation<
  APITypes.NotifyQueryValidationMutationVariables,
  APITypes.NotifyQueryValidationMutation
>;
export const UpdateScheduleStatus = /* GraphQL */ `mutation UpdateScheduleStatus($input: UpdateScheduleStatusInput!) {
  UpdateScheduleStatus(input: $input) {
    createdAt
    createdBy
    end {
      endAt
      maxOccurrences
      type
      __typename
    }
    lastModifiedAt
    lastModifiedBy
    name
    orgId
    queryId
    queryName
    queryType
    recurrence {
      frequency
      interval
      monthly {
        dayOfMonth
        dayOfWeek
        mode
        weekOfMonth
        __typename
      }
      weekly {
        days
        __typename
      }
      __typename
    }
    schedulerDescription
    schedulerId
    schedulerStatus
    startAt
    timezone
    type
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateScheduleStatusMutationVariables,
  APITypes.UpdateScheduleStatusMutation
>;
export const ValidateQueryRecord = /* GraphQL */ `mutation ValidateQueryRecord($queryRecord: QueryRecordRequest!) {
  ValidateQueryRecord(queryRecord: $queryRecord) {
    message
    statusCode
    success
    __typename
  }
}
` as GeneratedMutation<
  APITypes.ValidateQueryRecordMutationVariables,
  APITypes.ValidateQueryRecordMutation
>;
export const createQueryRecord = /* GraphQL */ `mutation CreateQueryRecord($queryRecordInput: CreateQueryRecordInput!) {
  createQueryRecord(queryRecordInput: $queryRecordInput) {
    athenaExecutionId
    createdAt
    createdBy
    description
    executionId
    executionSource
    executionStatus
    lastModifiedAt
    lastModifiedBy
    name
    orgId
    query
    queryId
    queryType
    status
    templateId
    validationLogs
    validationStatus
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateQueryRecordMutationVariables,
  APITypes.CreateQueryRecordMutation
>;
export const createSchedulerRecord = /* GraphQL */ `mutation CreateSchedulerRecord(
  $schedulerRecordInput: CreateSchedulerRecordInput!
) {
  createSchedulerRecord(schedulerRecordInput: $schedulerRecordInput) {
    createdAt
    createdBy
    end {
      endAt
      maxOccurrences
      type
      __typename
    }
    lastModifiedAt
    lastModifiedBy
    name
    orgId
    queryId
    queryName
    queryType
    recurrence {
      frequency
      interval
      monthly {
        dayOfMonth
        dayOfWeek
        mode
        weekOfMonth
        __typename
      }
      weekly {
        days
        __typename
      }
      __typename
    }
    schedulerDescription
    schedulerId
    schedulerStatus
    startAt
    timezone
    type
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateSchedulerRecordMutationVariables,
  APITypes.CreateSchedulerRecordMutation
>;
export const sendEmail = /* GraphQL */ `mutation SendEmail($input: SendEmailInput!) {
  sendEmail(input: $input) {
    body
    statusCode
    __typename
  }
}
` as GeneratedMutation<
  APITypes.SendEmailMutationVariables,
  APITypes.SendEmailMutation
>;
export const submitQuery = /* GraphQL */ `mutation SubmitQuery($input: SubmitQueryInput!) {
  submitQuery(input: $input) {
    executionId
    message
    orgId
    queryId
    statusCode
    success
    __typename
  }
}
` as GeneratedMutation<
  APITypes.SubmitQueryMutationVariables,
  APITypes.SubmitQueryMutation
>;
